import dynamic from 'next/dynamic'

export const DynamicProductInstructionsModal = dynamic(
  () => import('.').then((mod) => mod.ProductInstructionsModal),
  { ssr: false },
)
